import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "commonPantryDialogOverlay" }
const _hoisted_2 = { class: "pantry-detail-menu-view-area" }
const _hoisted_3 = { class: "pantry-detail-menu-view-item-delete-text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-menu-view-item-text" }, "食材を変更する", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-detail-menu-view-item-text" }, "キャンセル", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "pantry-detail-menu-view" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "pantry-detail-menu-view-item",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickDelete(...args)))
          }, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.getDeleteText()), 1)
          ]),
          (_ctx.isShow())
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "pantry-detail-menu-view-item",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickFoodChange(...args)))
              }, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: "pantry-detail-menu-view-item",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickClose(...args)))
          }, [
            _hoisted_5
          ])
        ])
      ])
    ]),
    _: 1
  }))
}